import { render, staticRenderFns } from "./BenefitsHome.vue?vue&type=template&id=71ddf186"
import script from "./BenefitsHome.vue?vue&type=script&lang=js"
export * from "./BenefitsHome.vue?vue&type=script&lang=js"
import style0 from "./BenefitsHome.vue?vue&type=style&index=0&id=71ddf186&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports